module.exports = __webpack_public_path__ + "img/five-star.0625182e.svg";